import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

// Three vertically-stacked dots, currentColor-driven like every other icon here - matches
// team-members.html's plain `.who-more` sidebar icon (no baked-in circle/color; the caller
// supplies its own hover-highlight background, e.g. v3's UserProfile menu toggle).
const EllipsisVertical = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ size, variant, className }))}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true">
    <circle cx="12" cy="5.5" r="1.9" />
    <circle cx="12" cy="12" r="1.9" />
    <circle cx="12" cy="18.5" r="1.9" />
  </svg>
);

export default EllipsisVertical;
